import { Lens, lens } from '@dhmk/zustand-lens';
import SystemConstants from '@/constants/SystemConstants';

import * as API from '@/types/api';
import * as UI from '@/types/ui';

export const createActivitySlice = () => {
  const createSlice: Lens<UI.ActivitySlice, UI.SessionStore> = (set, get, api) => {
    const slice = {
      away: API.AwayEnum.OFF,
      userActive: false,

      setUserActive: (active: boolean) => {
        set({ userActive: active });
      },

      setAway: (data: API.AwayState) => {
        set({ away: data.id });
      },
    };

    return slice;
  };

  return createSlice;
};

export const initActivityStore = async (
  sessionStore: UI.SessionStore,
  { socket }: UI.SessionStoreInitData,
) => {
  const url = SystemConstants.MODULE_URL;
  await socket.addListener(
    url,
    SystemConstants.AWAY_STATE,
    sessionStore.activity.setAway,
  );
};

export const createActivityStore = () => {
  return lens<UI.ActivitySlice, UI.SessionStore>((...a) => ({
    ...createActivitySlice()(...a),
  }));
};
